export const BotFeatures = {
  DETECT_ATTACHMENT_TYPE: 'DETECT_ATTACHMENT_TYPE',
  QUESTION_STEP_ATTACHMENT: 'QUESTION_STEP_ATTACHMENT',
  TELEPHONY_CHANNEL_CONFIG: 'TELEPHONY_CHANNEL_CONFIG',
  ALLOW_ALL_STEP_WITH_DISABLE_PROPERTY: 'ALLOW_ALL_STEP_WITH_DISABLE_PROPERTY',
  INTEGRATION_STEP_PDF_WATERMARK_SETTINGS: 'INTEGRATION_STEP_PDF_WATERMARK_SETTINGS',
  NLP_DISABLE_INTENT: 'NLP_DISABLE_INTENT',
  PROMPT_STEP_CUSTOM_VALIDATION_EXPRESSIONS: 'PROMPT_STEP_CUSTOM_VALIDATION_EXPRESSIONS',
  STEP_PREPROCESSOR: 'STEP_PREPROCESSOR',
  PROMPT_STEP_CUSTOM_PREPROCESSOR_EXPRESSIONS_OR_CODE:
    'PROMPT_STEP_CUSTOM_PREPROCESSOR_EXPRESSIONS_OR_CODE',
  PROMPT_STEP_DTMF_PLAYBACK: 'PROMPT_STEP_DTMF_PLAYBACK',
  QUERY_STRING_UTTERANCE_REPORT_API: 'QUERY_STRING_UTTERANCE_REPORT_API',
  SKIP_CURRENT_PLAYBACK_WITH_NEXT_MESSAGE: 'SKIP_CURRENT_PLAYBACK_WITH_NEXT_MESSAGE',
  PROMPT_STEP_AUTOSUGGEST: 'PROMPT_STEP_AUTOSUGGEST',
  REVAMPED_NLP_LOG: 'REVAMPED_NLP_LOG',
  ACTION_STEP_DTMF: 'ACTION_STEP_DTMF',
  NLP_INTENTS_WITH_DESCRIPTION: 'NLP_INTENTS_WITH_DESCRIPTION',
  UPDATE_AND_DEPLOY_HISTORY: 'UPDATE_AND_DEPLOY_HISTORY',
  NLP_KB_CHAT_PROVIDER: 'NLP_KB_CHAT_PROVIDER',
  PROMPT_WITH_ANSWERS: 'PROMPT_WITH_ANSWERS',
  INTEGRATION_LLM_GENERATE_TEXT: 'INTEGRATION_LLM_GENERATE_TEXT',
  INTEGRATION_LLM_INVOKE: 'INTEGRATION_LLM_INVOKE',
  REVAMPED_STEP_NLP_SETTINGS: 'REVAMPED_STEP_NLP_SETTINGS',
  GLOBAL_STORAGES: 'GLOBAL_STORAGES',
  AI_STEP: 'AI_STEP',
  NOTE_STEP: 'NOTE_STEP',
  WIZARD_MODE: 'WIZARD_MODE',
  REALTIME_CHANNEL: 'REALTIME_CHANNEL',
  REVAMPED_KB: 'REVAMPED_KB',
  NLP_CHAT_QUERIES: 'NLP_CHAT_QUERIES',
  AI_TESTER: 'AI_TESTER',
  STANDALONE_KNOWLEDGE_BASE: 'STANDALONE_KNOWLEDGE_BASE'
}

export const ReleaseFamily = {
  Feature: 'feature',
  Release: 'release',
  Master: 'master'
}
